/* ZAIRA FASHION — product page: live stock line, Buy It Now redirect, one-line action row, sticky bar. */
(function () {
  /* Change the WhatsApp number here only. */
  var WA_NUMBER = '923212488597';

  var WA_SVG = '<svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true"><path d="M16.04 3C9.37 3 3.98 8.39 3.98 15.06c0 2.23.61 4.32 1.66 6.12L3 29l8.02-2.6a12.02 12.02 0 0 0 5.02 1.1h.01c6.67 0 12.06-5.4 12.06-12.06C28.11 8.39 22.72 3 16.04 3zm0 21.98h-.01a9.9 9.9 0 0 1-5.05-1.38l-.36-.21-4.75 1.54 1.55-4.64-.24-.38a9.87 9.87 0 0 1-1.52-5.29c0-5.47 4.45-9.92 9.93-9.92 2.65 0 5.14 1.04 7.01 2.91a9.85 9.85 0 0 1 2.9 7.01c0 5.48-4.45 9.93-9.93 9.93zm5.44-7.43c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.65-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.48 1.06 2.87 1.21 3.07c.15.2 2.09 3.2 5.08 4.48.71.31 1.26.49 1.69.62.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35z"/></svg>';
  var BOLT_SVG = '<svg class="zf-bolt" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M13 2 3 14h7l-1 8 11-14h-7z"/></svg>';

  function currentVariantId() {
    var input = document.querySelector('.product-form__variants, input[name="id"]');
    if (input && input.value) return input.value;
    return new URL(window.location.href).searchParams.get('variant');
  }

  function currentQty() {
    var q = document.querySelector('.quantity__input');
    var v = q && q.value ? parseInt(q.value, 10) : 1;
    return (v && v > 0) ? v : 1;
  }

  function redirectBuyNow() {
    var id = currentVariantId();
    if (!id) return;
    window.location.href = '/cart/' + id + ':' + currentQty();
  }

  function waHref() {
    var title = document.title;
    var t = document.querySelector('.product__title h1, .product__title');
    if (t) title = t.textContent.trim();
    var msg = 'Hello! I would like to order this piece: ' + title + ' - ' + window.location.href;
    return 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(msg);
  }

  function renderStock() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var existing = info.querySelector('.mj-stock');
    var map = window.mjProductStock;
    var id = currentVariantId();
    var s = (map && id) ? map[String(id)] : null;

    if (!s || !s.tracked || s.qty > 5 || s.qty < 1) {
      if (existing) existing.remove();
      return;
    }
    var text = 'Only ' + s.qty + ' piece' + (s.qty > 1 ? 's' : '') + ' left';
    if (existing) { existing.querySelector('.mj-stock__text').textContent = text; return; }

    var el = document.createElement('p');
    el.className = 'mj-stock';
    el.innerHTML = '<span class="mj-stock__dot" aria-hidden="true"></span><span class="mj-stock__text">' + text + '</span>';
    var anchor = info.querySelector('.product-form') || info.querySelector('.price');
    if (anchor) anchor.insertAdjacentElement('beforebegin', el);
  }

  function syncActionAvailability() {
    var id = currentVariantId();
    var map = window.mjProductStock;
    var s = (map && id) ? map[String(id)] : null;
    var soldOut = !!(s && s.tracked && s.qty <= 0);
    var cartBtn = document.getElementById('zf-action-cart');
    var buyBtn = document.getElementById('zf-buynow');
    if (cartBtn) { cartBtn.disabled = soldOut; cartBtn.textContent = soldOut ? 'Sold Out' : 'Add to Cart'; }
    if (buyBtn) { buyBtn.disabled = soldOut; buyBtn.innerHTML = soldOut ? 'Sold Out' : (BOLT_SVG + 'Buy Now'); }
    var stickyCart = document.querySelector('.zf-sticky-bar__atc');
    var stickyBuy = document.querySelector('.zf-sticky-bar__buy');
    if (stickyCart) { stickyCart.disabled = soldOut; stickyCart.textContent = soldOut ? 'Sold Out' : 'Add to Cart'; }
    if (stickyBuy) { stickyBuy.disabled = soldOut; stickyBuy.innerHTML = soldOut ? 'Sold Out' : (BOLT_SVG + 'Buy Now'); }
  }

  function buildStickyBar() {
    if (document.querySelector('.zf-sticky-bar')) return;
    var titleEl = document.querySelector('.product__title h1, .product__title');
    var priceEl = document.querySelector('.product__info-container .price');
    var imgEl = document.querySelector('.product__media img, .product__media-item img');
    var trigger = document.querySelector('.zf-action-row') || document.querySelector('.product-form');
    if (!titleEl || !priceEl || !trigger) return;

    var bar = document.createElement('div');
    bar.className = 'zf-sticky-bar';
    bar.innerHTML =
      '<div class="zf-sticky-bar__info">' +
        (imgEl && imgEl.currentSrc ? '<img class="zf-sticky-bar__img" src="' + imgEl.currentSrc + '" alt="">' : '') +
        '<div class="zf-sticky-bar__text">' +
          '<span class="zf-sticky-bar__title">' + titleEl.textContent.trim() + '</span>' +
          '<span class="zf-sticky-bar__price">' + priceEl.textContent.trim().split(/\s{2,}/)[0] + '</span>' +
        '</div>' +
        '<span class="zf-sticky-bar__cod">COD Available \u2713</span>' +
      '</div>' +
      '<div class="zf-sticky-bar__actions">' +
        '<a class="zf-sticky-bar__wa" target="_blank" rel="noopener" aria-label="Order on WhatsApp" href="' + waHref() + '">' + WA_SVG + '</a>' +
        '<button type="button" class="zf-sticky-bar__atc">Add to Cart</button>' +
        '<button type="button" class="zf-sticky-bar__buy">' + BOLT_SVG + 'Buy Now</button>' +
      '</div>';
    document.body.appendChild(bar);

    bar.querySelector('.zf-sticky-bar__atc').addEventListener('click', function () {
      var mainBtn = document.querySelector('.product-form__submit');
      if (mainBtn) mainBtn.click();
    });
    bar.querySelector('.zf-sticky-bar__buy').addEventListener('click', redirectBuyNow);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', scrolledPast);
        });
      }, { threshold: 0 });
      io.observe(trigger);
    }
  }

  function init() {
    try {
      renderStock();
      buildStickyBar();
      syncActionAvailability();

      var buyBtn = document.getElementById('zf-buynow');
      if (buyBtn && !buyBtn.dataset.wired) {
        buyBtn.dataset.wired = '1';
        buyBtn.addEventListener('click', redirectBuyNow);
      }
      var cartBtn = document.getElementById('zf-action-cart');
      if (cartBtn && !cartBtn.dataset.wired) {
        cartBtn.dataset.wired = '1';
        cartBtn.addEventListener('click', function () {
          var real = document.querySelector('.product-form__submit');
          if (real) real.click();
        });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product-form__input')) {
      setTimeout(function () { renderStock(); syncActionAvailability(); }, 60);
    }
  });
})();
